module.exports = __webpack_public_path__ + "static/img/loading.717a1cf.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/loading.gif
// module id = JRsF
// module chunks = 5